import { type ReactNode } from "react";

import { Colors } from "@snapchat/snap-design-system";

import { CreatorRewardRecordEligibility } from "../../gql-generated/types";
import { formatWithUSFormat } from "../../lens-stats/formatters";
import { PostersNumberTag } from "../components/lens-source/LensCreatorRewardsInsights.styles";
import {
    NoPayoutReceived,
    NoRewardIssued,
    Pending,
    PendingMessage,
    PostersFromReward,
    Qualified,
    RewardIssued,
} from "../components/lens-source/messages.generated";

interface MakeDisplayMetaParams {
    withinDaysThreshold: boolean;
    rewardEligibility: CreatorRewardRecordEligibility;
    postersUniqueTotal: number;
    postersLeft: number;
    postUU: number;
}

interface DisplayMeta {
    postersText: ReactNode;
    postersHeading: ReactNode;
    postersTextColor: string;
}

export const makeDisplayMeta = ({
    withinDaysThreshold,
    rewardEligibility,
    postersUniqueTotal,
    postersLeft,
    postUU,
}: MakeDisplayMetaParams): DisplayMeta => {
    const reachedUniquePosters = postersLeft <= 0;
    if (withinDaysThreshold) {
        if (reachedUniquePosters) {
            return {
                postersText: <Qualified />,
                postersHeading: formatWithUSFormat(postersUniqueTotal),
                postersTextColor: Colors.Green.V200,
            };
        }
        return {
            postersText: (
                <>
                    <PostersNumberTag reachedUniquePosters={reachedUniquePosters}>
                        {formatWithUSFormat(postersLeft)}
                    </PostersNumberTag>{" "}
                    <PostersFromReward />
                </>
            ),
            postersHeading: formatWithUSFormat(postersUniqueTotal),
            postersTextColor: Colors.Black.V150,
        };
    }
    switch (rewardEligibility) {
        case CreatorRewardRecordEligibility.RewardEligibilityIneligible:
            return {
                postersText: <NoRewardIssued />,
                postersHeading: <NoPayoutReceived />,
                postersTextColor: Colors.Red.V150,
            };
        case CreatorRewardRecordEligibility.RewardEligibilityIssued:
            return {
                postersText: <RewardIssued />,
                postersHeading: formatWithUSFormat(postUU),
                postersTextColor: Colors.Green.V200,
            };
        default:
            return {
                postersText: <PendingMessage />,
                postersHeading: <Pending />,
                postersTextColor: Colors.Orange.V150,
            };
    }
};
